export const sp_chatDetails = {
  heading: 'Detalles de la Conversación',
  chatTooltip: 'El portal muestra hasta 6 meses de datos',
  createdOn: {
    label: 'Creado',
    info: 'Cuando el chat se inició en nuestro sistema.'
  },
  appointmentStatus: {
    label: 'Estado de la cita',
    info: 'Estado de la cita'
  },
  appointmentStartTime: {
    label: 'Hora de inicio',
    info: 'Hora de inicio'
  },
  appointmentEndTime: {
    label: 'Hora de finalización',
    info: 'Hora de finalización'
  },
  pickedUpOn: {
    label: 'Captada sobre',
    info: 'Cuando el chat se recogió en.'
  },
  pickedUpBy: {
    label: 'Recogido por',
    info: 'Quien recogió el chat.'
  },
  endedOn: {
    label: 'Finalizado',
    info: 'Cuando terminó el chat en nuestro sistema.'
  },
  leadFlag: {
    label: 'Bandera de plomo',
    info: 'Si la conversación de chat se convirtió en una ventaja válida.'
  },
  ip: {
    label: 'IP',
    info: 'La IP que se ha iniciado el chat.'
  },
  location: {
    label: 'Localización',
    info: 'La ubicación del visitante.'
  },
  referrer: {
    label: 'Referente',
    info: 'La de referencia, donde se inició el chat.'
  },
  chatTranscript: {
    label: 'Transcripción de la conversación',
    info: 'Transcripción de la conversación'
  }
};
export default sp_chatDetails;
